import { NotificationsState, NotificationData } from './types';

export default {
  addNotification(state: NotificationsState, notification: NotificationData): void {
    // Add to beginning of array (newest first)
    state.notifications.unshift(notification);

    // Limit to maxNotifications
    if (state.notifications.length > state.maxNotifications) {
      state.notifications = state.notifications.slice(0, state.maxNotifications);
    }
  },

  removeNotification(state: NotificationsState, notificationId: string): void {
    state.notifications = state.notifications.filter(n => n.id !== notificationId);
  },

  clearAll(state: NotificationsState): void {
    state.notifications = [];
  },

  updateNotification(state: NotificationsState, payload: { id: string; data: Partial<NotificationData> }): void {
    const notification = state.notifications.find(n => n.id === payload.id);
    if (notification) {
      Object.assign(notification, payload.data);
    }
  },
};

